/* eslint key-spacing: 'off', comma-spacing: 'off' */
import current from '@/scripts/current';
import commonTestHelper from '@/scripts/commonTestHelper';
import VariableSelection from '@/bo/VariableSelection';
import variableDataAccess from '@/scripts/variableDataAccess';
import store from '@/store';

function testToString(test) {
    return 'Years: ' + test.surveyYears + ' Variables: ' + test.variables;
}

export default {
    currentTestItem: 1,
    setIsInAutomatedTesting: function ($route) {
        if (process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'dev')
            return;
        if (window.inAutomatedTesting)
            return;
        window.inAutomatedTesting = $route && $route.query.test && $route.query.test.toLowerCase() === 'true';
    },
    setAutomatedTestValues: function (stepIndex, variableList) {
        var lastItem = variableList.length - 1;
        var test = variableList[commonTestHelper.currentTestItem];
        //setTest(stepIndex, [test.surveYear], [1], test.variables);  

        if (commonTestHelper.currentTestItem <= lastItem) {
            console.log('Test started. ' + testToString(variableList[commonTestHelper.currentTestItem]));
            console.log(test.surveyYears);
            current.testHelper.setTest(stepIndex, test.surveyYears, [1], test.variables);
        }

        //setTest(stepIndex, [2008, 2009], [1], ['R_PERSDOC2', 'R_RFDRMN3', 'R_AIDSTST']);
    },
    nextIfTesting: function ($router, success) {
        if (!window.inAutomatedTesting)
            return;

        let variableList = current.testHelper.getVariableList();
        if (success)
            console.log('Test successful. ' + testToString(variableList[commonTestHelper.currentTestItem]));
        else
            console.log('Test failed. ' + testToString(variableList[commonTestHelper.currentTestItem]));
        commonTestHelper.currentTestItem++;
        // if (commonTestHelper.currentTestItem > 3)
        //   return;
        var lastItem = variableList.length - 1;
        if (commonTestHelper.currentTestItem > lastItem)
            window.inAutomatedTesting = undefined;
        else if (current.startingPage)
            $router.push({ path: current.startingPage, query: { test: 'true' } });
    },
    setYearAsCompare: function (stepIndex, selectedYears) {
        var selectionType = 'compare';
        if (stepIndex >= current.navigation.stepIndex.years) {
            store.dispatch("selModel/setYearSelectionType", { selectionType });
            store.dispatch("selModel/setYears", { selectedYears });
        }
    },
    setYearAsCombine: function (stepIndex, selectedYears) {
        var selectionType = 'combine';
        if (stepIndex >= current.navigation.stepIndex.years) {
            store.dispatch("selModel/setYearSelectionType", { selectionType });
            store.dispatch("selModel/setYears", { selectedYears });
        }
    },
    setYearAs: function (stepIndex, selectedYear) {
        if (stepIndex >= current.navigation.stepIndex.years) {
            store.dispatch("selModel/setYearSelectionType", { selectedYear });
            store.dispatch("selModel/setYear", selectedYears);
        }
    },
    setLocationAsSingleByIndex: function (stepIndex) {
        if (stepIndex >= 2)
            store.dispatch('selModel/setLocations',
                {
                    selectionType: 'single',
                    locationIds: [store.state.dataLists.allLocations[0]]
                });
    },
    smartSetYears: function (stepIndex, years, isCompare) {
        if (stepIndex >= 1) {

            const selectionType = years.length === 1 ? 'single' :
                (isCompare ? 'compare' : 'combine');
            store.dispatch("selModel/setYearSelectionType", { selectionType });
            store.dispatch("selModel/setYears", { selectedYears: years });
        }
    },
    setLocations: function (stepIndex, locationIds, years, isCompare) {
        if (stepIndex >= 2) {
            var isAll = locationIds.length === 1 && locationIds[0] === 0;
            var isOne = !isAll && locationIds.length === 1;
            store.dispatch('selModel/setLocations', {
                selectionType: isOne || isAll ? 'single' : (isCompare ? 'compare' : 'combine'),
                locationIds: isAll ? '0' : locationIds
            });
        }
    },
    createVariableSelection: function (variable, year) {
        if (!variable)
            return VariableSelection.newNotIncluded();
        if (variable === 'year')
            return VariableSelection.newYear();
        if (variable === 'location')
            return VariableSelection.newLocation();
        var completeVariable = variableDataAccess.getByVariableName(variable);
        if (completeVariable === null) {
            console.log('Error on test: Variable Not Found: ' + variable + ', ' + year);
            return VariableSelection.newNotIncluded();
        }

        var variableSelection = VariableSelection.createFromVariable(completeVariable);
        return variableSelection;
    }
}

function getUnique(l, setObject) {
    var id = l.stateId;
    if (!setObject[id]) {
        setObject[id] = l;
        return l;
    } else
        return null;
}
function unique(locations) {
    var set = {};
    var setList = locations.map(l => getUnique(l, set))
        .filter(l => l != null);
    return setList;
}
